export default (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    alignItems: 'flex-start',
    padding: theme.spacing(2)
  },
  title: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
    fontWeight: '400'
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    marginTop: theme.spacing(1)
  },
  end: {
    marginBottom: theme.spacing(3)
  },
  sliderWrapper: {
    width: '200px'
  },
  spacer: {
    flexGrow: 1
  }
});
